import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import {
    getMatchesCountText,
    paginationLabels,
    Preferences,
    PROPERTY_FILTERING_I18N_CONSTANTS
} from "../../table-config";
import {
    Button,
    Header,
    Pagination,
    PropertyFilter,
    SpaceBetween,
    Table
} from "@amzn/awsui-components-react";
import { isNull } from "lodash";
import {ButtonDropdown, Checkbox} from "@amzn/awsui-components-react/polaris";
import { OBLIGATION_STATUS } from '../../../exception/components/common/constants';
import { getColumnDefinitions } from './table-config';
import ViewSummaryMetricsForSPAIN from "./ViewSummaryMetrics";
import {SPAIN_SII_DAILY_WORKFLOW_TYPE, SPAIN_SII_MONTHLY_WORKFLOW_TYPE} from "../../Constants/Constants";

export default function SpainSIITab(props) {
    const navigate = useNavigate();
    const {
        viewSummaryMetricsProps,
        collectionProps,
        selectedItems,
        preferences,
        items,
        paginationProps,
        propertyFilterProps,
        filteredItemsCount,
        setPreferences,
        setSelectedItems,
        statusFilterValue,
        actions,
        isSPAINSIIFiledChecked,
        setIsSPAINSIIFiledChecked,
        setSpainSIIType,
        spainSIIType
    } = props;

    const columnDefinitions = getColumnDefinitions(navigate);

    const onSelectionChange = (item) => {
        setSelectedItems(item.detail.selectedItems)
    };

    const {setPropertyFiltering} = actions;

    useEffect(() => {
        if (!isNull(statusFilterValue.spainTab)) {
            setPropertyFiltering({
                ...propertyFilterProps.query,
                tokens: [{
                    propertyKey: 'status',
                    operator: '=',
                    value: statusFilterValue.spainTab,
                }],
            })
        } else {
            setPropertyFiltering({
                ...propertyFilterProps.query,
                tokens: [],
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusFilterValue]);

    const isFilingBtnDisabled = () => {
        if (selectedItems.length === 1) {
            if (selectedItems[0].status === OBLIGATION_STATUS.UnderFiling) {
                return false;
            }
        }
        return true;
    }

    const filingBtnHandler = () => {
        navigate("../../filing", {replace: false});
    }

    const getSpainSIITableActions = () => {
        return (
            <SpaceBetween size='l' direction='horizontal'>
                <Checkbox checked={isSPAINSIIFiledChecked} onChange={event => { setIsSPAINSIIFiledChecked(event.detail.checked) }}>Include filed obligations</Checkbox>
                <ButtonDropdown items={[
                    {
                        "text": SPAIN_SII_DAILY_WORKFLOW_TYPE,
                        "id": SPAIN_SII_DAILY_WORKFLOW_TYPE
                    },
                    {
                        "text": SPAIN_SII_MONTHLY_WORKFLOW_TYPE,
                        "id": SPAIN_SII_MONTHLY_WORKFLOW_TYPE
                    }
                ]} onItemClick={(e) => {setSpainSIIType(e.detail.id)}}>{spainSIIType}</ButtonDropdown>
                <Button disabled={isFilingBtnDisabled()} onClick={filingBtnHandler}>Start filing</Button>
            </SpaceBetween>
        );
    };

    return (
        <SpaceBetween size="xl">
            <ViewSummaryMetricsForSPAIN
                summaryDataTitle={viewSummaryMetricsProps.summaryDataTitle}
                changeStatusFilterValue={viewSummaryMetricsProps.changeStatusFilterValue}
                tableData={viewSummaryMetricsProps.tableData} />
            <Table
                {...collectionProps}
                selectionType="multi"
                onSelectionChange={onSelectionChange}
                header={
                    <div>
                        <Header
                            counter={selectedItems.length ? `(${selectedItems.length}/${items.length})` : `(${items.length})`}
                            actions={getSpainSIITableActions()}
                        >
                            Obligations
                        </Header>
                    </div>
                }
                columnDefinitions={columnDefinitions}
                visibleColumns={preferences.visibleContent}
                selectedItems={selectedItems}
                items={items}
                pagination={<Pagination {...paginationProps} ariaLabels={paginationLabels}/>}
                filter={
                    <PropertyFilter
                        i18nStrings={PROPERTY_FILTERING_I18N_CONSTANTS}
                        filteringProperties={propertyFilterProps.filteringProperties}
                        filteringOptions={propertyFilterProps.filteringOptions}
                        onChange={propertyFilterProps.onChange}
                        query={propertyFilterProps.query}
                        countText={getMatchesCountText(filteredItemsCount)}
                    />
                }
                preferences={<Preferences preferences={preferences} setPreferences={setPreferences}/>}
            />
        </SpaceBetween>
    );
}